import { Col, Drawer, Table } from "antd";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { IoClose } from "react-icons/io5";
import md1 from "../../../assets/images/staticImages/c1.png";
import c6 from "../../../assets/images/staticImages/c6.png";
// import m1 from "../../../assets/images/staticImages/md1.png";
import p2 from "../../../assets/images/staticImages/pf1.png";
import p1 from "../../../assets/images/staticImages/pf2.png";
import { RangePicker, SubmitButton, TextComponent } from "../../../components";
import BatteryStatus from "../../../components/battery/Battery";
import Card from "../../../components/Card/Card";
import Switch from "../../../components/Switch/Switch";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import styles from "./reports.module.css";
import { useDispatch, useSelector } from "react-redux";
import { ScheduleMiddleware } from "../../../Store/Middlewares/ScheduleMiddleware";
import dummyImg from "../../../assets/images/dummy.png";
import m1 from "../../../assets/images/imagePlaceholder.png";
import moment from "moment";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import { MdOutlineResetTv, MdTimeToLeave } from "react-icons/md";
import { AssetsMiddleware } from "../../../Store/Middlewares/AssetsMiddleware";
import { CiTimer } from "react-icons/ci";

const dummydata = [
  {
    id: 1,
    key: "01",
    module: { image: m1, name: "Phoenix Immobilizer N16" },
    NewOwner: { image: p1, name: "Kathy Pacheco" },
    car: { image: md1, name: "Honda" },
    salesPerson: { image: p2, name: "William Rodriguez" },
    transferdate: "Nov 26, 2024",
  },
  {
    id: 2,
    key: "02",
    module: { image: m1, name: "Phoenix Immobilizer N16" },
    NewOwner: { image: p1, name: "Kathy Pacheco" },
    car: { image: md1, name: "Honda" },
    salesPerson: { image: p2, name: "William Rodriguez" },
    transferdate: "Nov 26, 2024",
  },
  {
    id: 3,
    key: "03",
    module: { image: m1, name: "Phoenix Immobilizer N16" },
    NewOwner: { image: p1, name: "Kathy Pacheco" },
    car: { image: md1, name: "Honda" },
    salesPerson: { image: p2, name: "William Rodriguez" },
    transferdate: "Nov 26, 2024",
  },
];
const Reports = () => {
  const { width } = useWindowDimensions();
  const [open, setOpen] = useState(false);
  const [showOwnerModal, setShowOwnerModal] = useState(false);
  const [value, setValue] = useState([]);
  const dispatch = useDispatch();
  const SALESHISTORY = useSelector(
    (state) => state.ScheduleReducer.salesHistory,
  );

  // console.log("SALESHISTORYYYYYYYYYYYYYYYY", SALESHISTORY);

  useEffect(() => {
    dispatch(
      ScheduleMiddleware.salesHistory({
        start_date:
          value?.length > 0 ? moment(value[0]?.$d).format("YYYY-MM-DD") : null,
        end_date:
          value?.length > 0 ? moment(value[1]?.$d).format("YYYY-MM-DD") : null,
      }),
    );
  }, []);

  const onApply = () => {
    if (value?.length < 2) {
      dispatch(
        showAlert({
          type: "Error",
          message: "Start and End date couldn't be empty",
        }),
      );
    } else {
      dispatch(
        ScheduleMiddleware.salesHistory({
          start_date:
            value?.length > 0
              ? moment(value[0]?.$d).format("YYYY-MM-DD")
              : null,
          end_date:
            value?.length > 0
              ? moment(value[1]?.$d).format("YYYY-MM-DD")
              : null,
        }),
      );
    }
  };

  const revoke = {
    title: "Revoke Sold Module",
    dataIndex: "revoke",
    key: "revoke",
    render: (item, data) => (
      <div>
        <MdOutlineResetTv
          size={25}
          style={{
            cursor: data?.can_revert_able ? "pointer" : "not-allowed",
            color: !data?.can_revert_able ? "lightgrey" : "red",
          }}
          onClick={() =>
            data?.can_revert_able
              ? dispatch(
                  ScheduleMiddleware.revertStoreModule({
                    assetId: data?.asset_id,
                    userId: data?.owner?.id,
                    module_id: data?.module_id,
                  }),
                ).then(() => {
                  const filteredAssets = SALESHISTORY?.history.filter(
                    (asset) => asset.asset_id !== data?.asset_id,
                  );
                  dispatch(ScheduleMiddleware.salesHistory({ filteredAssets }));
                })
              : null
          }
        />
      </div>
    ),
  };

  const duration = {
    title: "Remaining Days to Revoke",
    dataIndex: "revoke",
    key: "revoke",
    render: (item, data) => (
      <div className="flex-start" style={{ gap: 5 }}>
        <CiTimer
          size={25}
          style={{
            color: !data?.can_revert_able ? "lightgrey" : "red",
          }}
        />
        <TextComponent
          text={`${data?.days_remaining_for_revert} days`}
          className={styles.versionText}
        />
      </div>
    ),
  };

  const columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (text, index, data) => (
        <div>
          <TextComponent text={data + 1} className={styles.versionText} />
        </div>
      ),
    },
    {
      title: "Device",
      dataIndex: "module",
      key: "module",
      render: (item, data) => (
        <div className={styles.module}>
          <img
            src={data?.module_image ? data?.module_image : m1}
            className={styles.moduleImg}
          />
          <TextComponent
            text={data?.module_device_id ? data?.module_device_id : "--"}
            className={styles.moduletext}
          />
        </div>
      ),
    },
    // {
    //   title: "Make",
    //   dataIndex: "car",
    //   key: "car",
    //   render: (item) => (
    //     <div className={styles.module}>
    //       <img src={item?.image} className={styles.moduleImg} />
    //       <TextComponent text={item?.name} className={styles.moduletext} />
    //     </div>
    //   ),
    // },
    {
      title: "Owner",
      dataIndex: "Owner",
      key: "Owner",
      render: (item, data) => (
        <div
          className={styles.module}
          onClick={(e) => {
            e.stopPropagation();
            setShowOwnerModal(true);
          }}
        >
          <img
            src={
              data?.owner?.profile_picture
                ? data?.owner?.profile_picture
                : dummyImg
            }
            className={styles.personImg}
          />
          <TextComponent
            text={data?.owner?.name ? data?.owner?.name : "--"}
            className={styles.persontext}
          />
        </div>
      ),
    },

    {
      title: "Sales Person",
      dataIndex: "salesPerson",
      key: "salesPerson",
      render: (item, data) => (
        <div className={styles.module}>
          <img
            src={
              data?.sales_person?.profile_picture
                ? data?.sales_person?.profile_picture
                : dummyImg
            }
            className={styles.personImg}
          />
          <TextComponent
            text={data?.sales_person?.name ? data?.sales_person?.name : "--"}
            className={styles.pText}
          />
        </div>
      ),
    },

    {
      title: "Transfer Date",
      dataIndex: "date",
      key: "date",
      render: (item, data) => (
        <div className={styles.module}>
          <TextComponent text={item} />
        </div>
      ),
    },
  ];
  const chartData = Object.values(SALESHISTORY?.labels || {});
  const maxValue = Math.max(...chartData);
  return (
    <div className={styles.reportsContainer}>
      <div className={styles.reportsHeader}>
        <TextComponent text="Reports" className={styles.reportsHeading} />
        <Col
          className={styles.filterContainer}
          //   key={key}
          xs={{ flex: "100%" }}
          sm={{ flex: "50%" }}
          md={{ flex: "49%" }}
          lg={{ flex: "24%" }}
          xl={{ flex: "24%" }}
        >
          {" "}
          <TextComponent text="By Date: " className={styles.filterHeading} />
          <RangePicker value={value} setValue={setValue} onApply={onApply} />
        </Col>
      </div>

      <Card className={styles.orderMain}>
        <div className={styles.orderMainCont}>
          <TextComponent text="Sales overview" className={styles.headerHead} />
        </div>
        <Bar
          height={80}
          options={{
            responsive: true,
            plugins: {
              legend: {
                position: "top",
              },
              title: {
                align: "start",
                display: true,
                text: SALESHISTORY ? SALESHISTORY?.total_sailed_units : "0",
                color: "#ED1C24",
                font: { size: 30, family: "Urbanist" },
              },

              subtitle: {
                align: "start",
                display: true,
                text: "Units",
                color: "#ED1C24",
                font: { size: 18, family: "Urbanist", weight: "bold" },
              },
            },
            scales: {
              y: {
                beginAtZero: true,
                min: 0,
                max: maxValue + 20,
                ticks: {
                  stepSize: 20,
                },
              },
            },
          }}
          data={{
            datasets: [
              {
                label: "Sales overview",
                // data:
                data: Object.values(SALESHISTORY?.labels || {}),
                backgroundColor: "#0050A8",
              },
            ],
            labels: Object.keys(SALESHISTORY?.labels || {}),
          }}
        />
      </Card>

      <Card className={styles.orderMain}>
        <div className={styles.orderMainCont}>
          <TextComponent text="History" className={styles.historyHead} />
        </div>
        <Table
          //   title={}
          scroll={{ x: true }}
          bordered={false}
          pagination={false}
          columns={[...columns, revoke, duration]}
          dataSource={SALESHISTORY?.history}
          onRow={(record, rowIndex) => {
            return {
              // onClick: () => {
              //   setOpen(true);
              // },
              // style: { cursor: "pointer" },
            };
          }}
        />
      </Card>
      <Drawer
        width={width < 550 ? "100%" : 600}
        headerStyle={{ display: "none" }}
        onClose={() => {
          setOpen(false);
          // setDetails([]);
        }}
        open={open}
      >
        {/* <div className={styles.drawerImgDiv}> */}
        {/* <img src={c6} className={styles.drawerImg} /> */}
        <div
          className={styles.crossIconDiv}
          onClick={() => {
            setOpen(false);
            // setDetails([]);
          }}
        >
          <IoClose />
          {/* </div> */}
        </div>
        <div className={styles.rightCol}>
          <Card>
            <img src={c6} alt="" className={styles.slectedImg} />
            <div className={styles.leftHeader}>
              <div>
                <TextComponent
                  text={"Honda Accord"}
                  className={styles.heading}
                />
                <TextComponent
                  text={"License Plate: ABC1234"}
                  className={styles.carDescText}
                />
                <TextComponent
                  text={"VIN: 4T1B11HK6MU123456"}
                  className={styles.carDescText}
                />
                <TextComponent text={"2016"} className={styles.carDescText} />
                <TextComponent
                  text={"Location: Lot A, Row 5"}
                  className={styles.carDescText}
                />
              </div>
              <div>
                {/* <Dropdown
                        trigger={"click"}
                        menu={
                          {
                            // items: items2,
                          }
                        }
                        placement="bottomRight"
                        arrow={{
                          pointAtCenter: true,
                        }}
                      >
                        <button className={styles.menubtn}>
                          <SlOptionsVertical
                            size={20}
                            color="var(--light-text)"
                            cursor={"pointer"}
                          />
                        </button>
                      </Dropdown> */}
              </div>
            </div>
          </Card>

          <Card className={styles.card}>
            <div className={styles.leftHeader}>
              <div>
                <TextComponent
                  text={"Phoenix Immobilizer"}
                  className={styles.heading}
                />
                <TextComponent
                  text={"Connected via LoRaWAN"}
                  className={styles.carDescText}
                />
                <TextComponent
                  text={"VIN: 4T1B11HK6MU123456"}
                  className={styles.carDescText}
                />

                <BatteryStatus percentage={85} />
                <div className={styles.scheduleLeftCont}>
                  <Switch
                    isChecked={true}
                    size="small"
                    // style={
                    //   item.isImobilized
                    //     ? { backgroundColor: "var(--primary-color)" }
                    //     : { backgroundColor: "var(--green-color)" }
                    // }
                    // onChange={() => {}}
                    disabled
                  />
                  <TextComponent text={"Immobilized"} className={styles.text} />
                </div>
              </div>
              <div>
                {/* <Dropdown
                        trigger={"click"}
                        menu={
                          {
                            // items: items1,
                          }
                        }
                        placement="bottomRight"
                        arrow={{
                          pointAtCenter: true,
                        }}
                      >
                        <button className={styles.menubtn}>
                          <SlOptionsVertical
                            size={20}
                            color="var(--light-text)"
                            cursor={"pointer"}
                          />
                        </button>
                      </Dropdown> */}
              </div>
            </div>
          </Card>
          <Card className={styles.card}>
            <TextComponent text={"Access details"} className={styles.heading} />
            <div className={styles.leftHeader}>
              <div>
                <TextComponent
                  text={"Owner: James Hall"}
                  className={styles.carDescText}
                />
              </div>
              <div>
                <TextComponent
                  text={"Ownership Transferred"}
                  className={styles.ownerText}
                />
              </div>
            </div>
          </Card>
        </div>
      </Drawer>
    </div>
  );
};

export default Reports;
